<ngx-spinner bdColor="rgba(0,0,0,0.56)" size="medium" color="#008F99" type="ball-clip-rotate-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
  </ngx-spinner>
